export default __webpack_public_path__ + "static/media/mantenimientoSVG.32c355b7.svg";